import { render, staticRenderFns } from "./OptionFieldNames.vue?vue&type=template&id=2a283814"
import script from "./OptionFieldNames.vue?vue&type=script&lang=js"
export * from "./OptionFieldNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports